exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Header-module__header__1QwaW {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin: 40px 30px 20px;\r\n}", ""]);

// exports
exports.locals = {
	"header": "Header-module__header__1QwaW"
};